import { Injectable, ErrorHandler, Injector } from '@angular/core';
// import * as Raven from 'raven-js';
import { APIURLs } from '../api-urls';

// Raven
//   .config('https://cb16ec988e08400b962eb09e251bf412@sentry.choicetechlab.com/80', { release: '11ed4f3cac5611e9bea94ec2f1eb4b47' })
//   .install();
/**
 * Onboard Error Handler
 */
@Injectable()
/** Onboard Error Handler */
export class OnboardErrorHandler implements ErrorHandler {
  /** Getting Session storage  */
  private storage: Storage;
  /**  API url from APIURLS component */
  private urls: APIURLs;
  
  /**
   * Storing localStorage Data
   * Getting API url and assign
   * @param injector instance of injector
   */
  constructor(private injector: Injector) {
    // this.storage = window.sessionStorage || window.localStorage;
    this.storage = window.sessionStorage;
    this.urls = this.injector.get(APIURLs);
  }

  /**
   * Error handling
   * @param error Getting error 
   * @param url  passing URL
   */
  handleError(error: any, url?: any): void {
    console.error(error);
    // let extraData = { investorId: (this.getOnboardingData() || {}).id, businessUnit: this.getBusinessUnit(), version: this.urls.version };
    // Raven.captureException(error, { extra: extraData });
  }

  /** ignore */
  private getOnboardingData() {
    if (this.storage) {
      let businessUnit = this.getBusinessUnit();
      let data = this.storage.getItem(businessUnit);
      if (data) return JSON.parse(data);
      return {};
    }
    return {};
  }

  /** identify Business unit MF or JF */
  getBusinessUnit() {
    let href = location.href.toLowerCase();
    return href.indexOf('/mf/') > -1 || href.indexOf('/connect-mf/') > -1 ? 'MF' :
      href.indexOf('/trading/') > -1 || href.indexOf('/connect-trading/') > -1 ? 'JF' :
        href.indexOf('/mf-trading/') > -1 || href.indexOf('/connect-mf-trading/') > -1 ? 'MFJF' : 'MFJF';
  }
}
